<div
  class="bottom-container flex-column justify-start align-stretch"
  [ngClass]="{ 'no-padding': noPadding, 'no-shadow': noShadow }"
  >
  @if (hasLogo) {
    <app-logo class="show-gt-xs" [logoType]="'horizontal'"></app-logo>
  }

  @if (title) {
    <div class="title">
      <span>{{ title }}</span>
    </div>
  }

  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
